import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search) => {
  return await GET(
    `/admin/masters/app-setup?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}`
  );
};

export const findOne = async (id) => {
  return await GET(`/admin/masters/app-setup/${id}`);
};

export const Create = async (data) => {
  return await POST(`/admin/masters/app-setup`, data);
};

export const Update = async (id, data) => {
  return await PUT(`/admin/masters/app-setup/${id}`, data);
};

export const Status = async (id) => {
  return await POST(`/admin/masters/app-setup/${id}`);
};

export const Delete = async (id) => {
  return await DELETE(`/admin/masters/app-setup/${id}`);
};
